export const COLUMN_WIDTHS = {
  ACCOUNT: 120,
  CREATED_ON: 125,
  CUSTOMER: 125,
  DESIGNER: 125,
  FEEDBACK: 250,
  NAME: 280,
  REASONS: 250,
};
